<template lang="pug">
  .sign-up
    //- MODAL DE EXITO
    v-dialog(v-model="showModal", persistent, width="360")
      v-card.sign-up-modal
        figure.text-xs-center
          img(:src="icons.exito" alt="Registro exitoso" width="150")
        h2.omnesMedium.text-blue-gray.text-xs-center {{ txtLastStep }}
        p.mt-3.text-xs-center(v-if="source=='recovery'") Sigue disfrutando de todos los beneficios que te ofrecemos en nuestra zona exclusiva para clientes.
        p.mt-3.text-xs-center(v-else) Ya puedes ingresar a consultar los datos de tu póliza, actualizar tus datos, descargar estados de cuenta, etc.
        button.omnesSemibold.zs-btn-fill.fuchsia(@click="goToHome(true)") Entendido
    //- MODAL RESEND CODE
    v-dialog(v-model="showModalResendCode", persistent, width="360")
      v-card.sign-up-modal
        figure.text-xs-center
          img(:src="icons.informa" alt="Reenvío de código")
        h2.omnesMedium.text-blue-gray.text-xs-center El código ha sido enviado nuevamente
        p.mt-3.text-xs-center Tu código llegará en breve, verifica que esté ingresado correctamente.
        button.omnesSemibold.zs-btn-fill.fuchsia(@click="confirmResendCode()") Entendido
    //- MODAL REVISAR SPAM
    SpamReminderModal(v-model="showModalSpamReminder")
    //- MODAL DE ERROR
    v-dialog(v-model="showModalErr", persistent, width="360")
      v-card.sign-up-modal
        figure.text-xs-center
          img(:src="icons.error" alt="iconError" class="mt-2")
        h2.omnesMedium.text-blue-gray.text-xs-center ¡Lo sentimos!
        p.mt-3.text-xs-center {{ parrafErr }}
          a.omnesMedium.g-text-gray-700(
            v-if="!parrafErr.includes('código incorrecto') && !parrafErr.includes('seleccionar todas las preguntas')"
            :href="links.Home" target="_blank") canales digitales
          | .
        button.omnesSemibold.zs-btn-fill.fuchsia(@click="goToLogin()") Entendido
    Cover(:logo="icons.logo")
    .sign-up-col-two.g-flex.g-align-center
      .sign-up-col-two-container
        section.sign-up-col-two-main
          //- CREAR CUENTA
          article.sign-up-create-user(v-show="showCreateUserOption")
            h2.omnesSemibold(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") {{ titleSignUp }}
            p.text-instruction.mt-1(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") {{ subTitleSignUp }}
            .sign-up-email-phone(:class="{ 'mt-4': $vuetify.breakpoint.smAndDown }")
              label(v-for="(option, index) in options" :key="option.value" :for="option.value === 2 ? 'celular' : 'correo'").g-align-center.g-flex
                input(type="radio" :id="option.value === 2 ? 'celular' : 'correo'" name="radioUserCreate" @click="optionCreateUser(option)")
                p.mb-0
                  span.g-text-gray-700.omnesMedium {{ option.value === 2 ? 'Celular' : 'Correo electrónico' }}
            button.omnesRegular.zs-btn-fill.sign-up-send-code(:disabled="!activeBtnSendCodeCreateUser", :class="{'fuchsia': activeBtnSendCodeCreateUser}", @click="sendCode") Validar datos
            p.omnesMedium.zs-btn-inline-blue.text-xs-center.sign-up-create-user-data(@click="showUpdateDataPopup") Quiero actualizar mi celular y/o correo electrónico
          //- VERIFICACIÓN DE CÓDIGO
          article(v-show="showCreateUserCode")
            h2.omnesSemibold(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Verificación de código
            p.mt-1.mb-4.text-instruction(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Ingresa el código enviado al {{ medioEnvio }}.
            .sign-up-code
              h3.text-xs-center Ingresa el código
              .g-align-center.g-flex.mt-3
                input(type="text", v-model="txt1CodeCreateUser", maxlength=1, ref="input1", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 1)")
                input(type="text", v-model="txt2CodeCreateUser", maxlength=1, ref="input2", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 2)")
                input(type="text", v-model="txt3CodeCreateUser", maxlength=1, ref="input3", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 3)")
                input(type="text", v-model="txt4CodeCreateUser", maxlength=1, ref="input4", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 4)")
                input(type="text", v-model="txt5CodeCreateUser", maxlength=1, ref="input5", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 5)")
                input(type="text", v-model="txt6CodeCreateUser", maxlength=1, ref="input6", @keypress="verifychars($event)", @keyup="changeCodeCreateUser($event, 6)")
              p.mb-0.text-xs-center.mt-4.g-text-gray-700
                | El código tiene vigencia de&nbsp;
                span.font-weight-bold.text-blue-gray
                  | 1 hora&nbsp;
            button.omnesRegular.zs-btn-fill.sign-up-btn-login(:class="{'fuchsia': activeBtnCodeCreateUser}", :disabled="!activeBtnCodeCreateUser", @click="goToQuestion") Continuar
            p.mt-3.mb-5.zs-btn-inline-blue.text-xs-center.omnesMedium(@click="resendCode()") No he recibido mi código de confirmación
          //- VERIFICA TUS DATOS
          article(v-show="showCreateUserVerifyData").sign-up-verify-data
            h2.omnesSemibold(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") {{ titleVerifyData }}
            p.text-instruction(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") {{ subTitleVerifyData }}
            p.password-description.mt-2.mb-3(v-if="source === 'recovery'") Por tu seguridad, la nueva contraseña debe  ser distinta a la anterior y cumplir con los requisitos mínimos especificados en la lista.
            p.password-description.mt-2.mb-3(v-else) Por tu seguridad, la nueva contraseña debe  cumplir con los requisitos mínimos especificados en la lista.
            //- CR Auth no devuelve celular ni correo: los datos de contacto solo se muestran al actualizarlos
            h3.text-blue-gray.mt-3.mb-2(v-if="updateDataInRecoveryMode") Datos de contacto
            v-text-field(v-if="updateDataInRecoveryMode", label="Celular", outline, v-model="txtPhoneVerifyData", browser-autocomplete="off", @keypress="onlyNumbers($event)", @keyup="changePassConfirm($event, null)", :disabled="!updateDataInRecoveryMode ? true : false")
              template(v-slot:append='', v-if="updateDataInRecoveryMode")
                img(:src="icons.iconPencil" alt="iconPencil")
            v-text-field(v-if="updateDataInRecoveryMode", label="Correo electrónico", id="txtEmailVerifyData", browser-autocomplete="off", outline, v-model="txtEmailVerifyData", @keyup="changePassConfirm($event, 'email')", :disabled="!updateDataInRecoveryMode ? true : false")
              template(v-slot:append='', v-if="updateDataInRecoveryMode")
                img(:src="icons.iconPencil" alt="iconPencil")
            h3.text-blue-gray.mt-1 Crea tu contraseña
            v-text-field.eye-password(label="Contraseña", :type="typePassword", outline, v-model="txtPassVerifyData", browser-autocomplete="off", hide-details, id="txtPassVerifyData", @keyup="changePassConfirm($event, 'password')" @focus="showPasswordChecklist = true" :class="{'has-content': txtPassVerifyData && txtPassVerifyData.length > 0}")
              template(v-slot:append='')
                img(:src="icons.eyeSelected", alt="eyeClose", @click="showHidePassword()")
            //- BARRA DE PROGRESO Y CHECKLIST DE VALIDACIÓN
            .password-checklist.mt-2.mb-3(v-if="showPasswordChecklist")
              .password-progress-container.mb-3
                .password-progress-bar
                  .password-progress-fill(:style="{ width: passwordProgress + '%' }")
                p.password-progress-title.omnesMedium {{ passwordProgressText }}
              .password-requirement(v-for="(requirement, index) in passwordRequirements" :key="index")
                span.check-icon(:class="{'check-valid': requirement.valid && requirement.hasContent, 'check-invalid': !requirement.hasContent, 'check-error': requirement.hasContent && !requirement.valid}")
                  img(v-if="requirement.valid && requirement.hasContent" :src="icons.checkValid" alt="check")
                  img(v-else-if="requirement.hasContent && !requirement.valid" :src="icons.checkInvalid" alt="error")
                span.requirement-text {{ requirement.text }}
            v-text-field(label="Reescribe contraseña", :type="typePassword", outline, v-model="txtPassConfirmVerifyData", browser-autocomplete="off", hide-details, id="txtPassConfirmVerifyData", @keyup="changePassConfirm($event, null)")
            //- p.g-text-gray-700(v-bind:class="{ 'size-12px': $vuetify.breakpoint.smAndDown }")
              | Al continuar, acepto las&nbsp;
              a.omnesMedium(:href="files.pdfPrivacy" target="_blank") condiciones de uso y políticas de privacidad
            p.g-text-gray-700.terms(v-if="updateDataInRecoveryMode", v-bind:class="{ 'size-12px': $vuetify.breakpoint.smAndDown }")
              | Al continuar, acepto la actualización de los datos, los cuales serán utilizados como contacto legal para notificar la póliza y demás documentos asociados a su contrato.
            button.omnesRegular.zs-btn-fill.sign-up-btn-verify-data.mb-3(:class="{'fuchsia' : activeBtnVerifyData}", :disabled="!activeBtnVerifyData", @click="finishSignIn") Continuar
          //- PREGUNTAS DE VERIFICACIÓN
          article(v-show="showQuestionVerify").sign-up-question-verify
            h2.omnesSemibold(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Preguntas de verificación
            p.text-instruction.mt-1.mb-3(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Crea tu cuenta respondiendo estas 3 preguntas de seguridad.
            div
              h3.text-blue-gray ¿Cuál fue el último producto que contrataste con Interseguro?
              .g-flex
                p(v-for="item in dataQuestion1", :key="item.id",:class="{'back-blue': item.active }", @click="activeQuestion1(item)").transition-all-3.g-text-gray-500 {{item.text}}
            div.mt-3(v-show="showQuestionVerifySection2")
              h3.text-blue-gray ¿Cuál fue el año de contratación del seguro seleccionado?
              .g-flex
                p(v-for="item in dataQuestion2", :key="item.id",:class="{'back-blue': item.active }", @click="activeQuestion2(item)").transition-all-3.g-text-gray-500 {{item.text}}
            div.mt-3(v-show="showQuestionVerifySection3")
              h3.text-blue-gray ¿Cuál fue el canal de compra del seguro seleccionado?
              .g-flex
                p(v-for="item in dataQuestion3", :key="item.id",:class="{'back-blue': item.active }", @click="activeQuestion3(item)").transition-all-3.g-text-gray-500 {{item.text}}
            button.omnesRegular.zs-btn-fill.mt-5.mb-5(:disabled="!activeBtnQuestionVerify", :class="{'fuchsia': activeBtnQuestionVerify}", @click="goToVerifyData") Continuar
          //- CAMBIAR CONTRASEÑA
          article(v-show="showChangePass").sign-up-change-password
            h2.omnesSemibold(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Cambiar contraseña
            h3.text-instruction(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Ingresa tu nueva contraseña
            p.text-instruction.my-3(:class="{ 'text-xs-center': $vuetify.breakpoint.smAndDown }") Por tu seguridad, la nueva contraseña debe  ser distinta a la anterior y cumplir con los requisitos mínimos especificados en la lista.
            v-text-field.eye-password(label="Contraseña", :type="typePassword", browser-autocomplete="off", outline, v-model="txtPassVerifyData", hide-details, @keyup="changeForgotPassConfirm($event, 'password')" @focus="showPasswordChecklistRecovery = true" :class="{'has-content': txtPassVerifyData && txtPassVerifyData.length > 0}")
              template(v-slot:append='')
                img(:src="icons.eyeSelected", alt="eyeClose", @click="showHidePassword()")
            br(v-if="passwordIsValid")
            p.error--message.error--text.size-13px(v-if="!passwordIsValid") Por favor, revisar que la contraseña ingresada sea válida.
            //- BARRA DE PROGRESO Y CHECKLIST DE VALIDACIÓN (para recuperación)
            .password-checklist.mt-2.mb-3(v-if="showPasswordChecklistRecovery")
              .password-progress-container.mb-3
                .password-progress-bar
                  .password-progress-fill(:style="{ width: passwordProgress + '%' }")
                p.password-progress-title.omnesMedium {{ passwordProgressText }}
              .password-requirement(v-for="(requirement, index) in passwordRequirements" :key="index")
                span.check-icon(:class="{'check-valid': requirement.valid && requirement.hasContent, 'check-invalid': !requirement.hasContent, 'check-error': requirement.hasContent && !requirement.valid}")
                  img(v-if="requirement.valid && requirement.hasContent" :src="icons.checkValid" alt="check")
                  img(v-else-if="requirement.hasContent && !requirement.valid" :src="icons.checkInvalid" alt="error")
                span.requirement-text {{ requirement.text }}
            v-text-field(label="Reescribe contraseña", :type="typePassword", browser-autocomplete="off", outline, v-model="txtPassConfirmVerifyData", @keyup="changeForgotPassConfirm")
            button.omnesRegular.zs-btn-fill.sign-up-btn-verify-data.my-4(:class="{'fuchsia' : activeBtnChangePass}", :disabled="!activeBtnChangePass", @click="finishSignIn") Crear nueva contraseña
    //- LOADER PROCESS
    v-layout
      v-dialog(v-model="loader" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | {{ textLoading }}...
            v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import FormSignup from '@/components/FormSignup'
import { getHashIS } from '../interfaces/sha256'
import Navbar from '@/components/login/Navbar'
import Cover from '@/components/login/Cover'
import SpamReminderModal from '@/components/SpamReminderModal'
import Links from '../interfaces/links'
import { validatePasswordFormat, PASSWORD_REGEX } from '@/utils/passwordValidation'
import { RECAPTCHA_ACTIONS } from '../constants'
import authIntegration from '@/integrations/auth.integration'
import passwordIntegration from '@/integrations/password.integration'
import { AUTH_ERROR_CODES } from '@/integrations/models/auth.models'
import environment from '@/utils/environment'
import { toDocumentType, toChannel, toRecaptchaToken } from '@/interfaces/authMappers'

/** Códigos de portal-api al definir la contraseña: el token no se consume y se puede reintentar. */
const PASSWORD_SETUP_RETRY_CODES = ['98', '97']

const rand = n => Math.floor(Math.random() * n)

export default {
  props: ['source', 'numeroDocumento', 'tipoDocumento', 'nombreUsuario', 'apellidoPaterno', 'apellidoMaterno'],
  data () {
    return {
      links: Links,
      time: moment(60 * 3 * 1000),
      showModalErr: false,
      parrafErr: '',
      loader: false,
      textLoading: '',
      valorMedioEnvio: '',
      medioEnvio: '',
      optionSelected: null,
      interval: null,
      codigoUsuario: '',
      // OTP de CR Auth: el passwordSetupToken vive solo aquí (no se persiste)
      verificationId: null,
      passwordSetupToken: null,
      passwordSetupExpiresAt: 0,
      txtLastStep: '',
      dataQuestion1: [],
      dataQuestion2: [],
      dataQuestion3: [],
      options: [],
      titleVerifyData: '',
      subTitleVerifyData: '',
      titleSignUp: '',
      subTitleSignUp: '',
      emailIsCorrect: false,
      passwordIsValid: true,
      activeBtnCodeCreateUser: false,
      activeBtnSendCodeCreateUser: false,
      activeBtnCreateUser: false,
      activeBtnVerifyData: false,
      activeBtnQuestionVerify: false,
      activeBtnChangePass: false,
      showCreateUserOption: true,
      showCreateUserCode: false,
      showCreateUserVerifyData: false,
      showQuestionVerify: false,
      showChangePass: false,
      showQuestionVerifySection2: false,
      showQuestionVerifySection3: false,
      showModal: false,
      showModalResendCode: false,
      showModalSpamReminder: false,
      updateDataInRecoveryMode: false,
      showPasswordChecklist: false,
      showPasswordChecklistRecovery: false,
      txt1CodeCreateUser: '',
      txt2CodeCreateUser: '',
      txt3CodeCreateUser: '',
      txt4CodeCreateUser: '',
      txt5CodeCreateUser: '',
      txt6CodeCreateUser: '',
      txtPhoneVerifyData: '',
      txtEmailVerifyData: '',
      txtPassVerifyData: '',
      txtPassConfirmVerifyData: '',
      showPassword: false,
      typePassword: 'password',
      original: {
        email: '',
        phone: ''
      },
      icons: {
        logo: require('@/assets/logo.svg'),
        main: require('./../assets/cvc/icon_2_signup.svg'),
        phone: require('./../assets/cvc/icon_phone.svg'),
        message: require('./../assets/cvc/icon_message.svg'),
        iconPencil: require('./../assets/cvc/icon_pencil_login.svg'),
        iconFinishgSignup: require('./../assets/cvc/icon_finish_signup.svg'),
        iconError: require('./../assets/cvc/icon_error.svg'),
        eyeSelected: require('@/assets/icons/icon-eye-close.svg'),
        eyeClose: require('@/assets/icons/icon-eye-close.svg'),
        eyeOpen: require('@/assets/icons/icon-eye-open.svg'),
        informa: require('@/assets/characters/informa.svg'),
        error: require('@/assets/characters/sorprendido.svg'),
        oops: require('@/assets/characters/oops.svg'),
        exito: require('@/assets/characters/exitoso.gif'),
        checkValid: require('@/assets/icons/icon-check-valid.svg'),
        checkInvalid: require('@/assets/icons/icon-check-invalid.svg')
      },
      files: {
        pdfPrivacy: require('./../assets/downloable/autorizacion-para-el-uso-y-tratamiento-de-datos-personales.pdf')
      },
      trackEvents: {
        access: {
          category: 'Actualización de Datos',
          action: 'Acceso',
          label: 'Acceso OK',
          event: 'ACT_DATOS Acceso',
          producto: ''
        },
        questions_ok: {
          category: 'Actualización de Datos',
          action: 'Acceso',
          label: 'Respuestas correctas',
          event: 'ACT_DATOS Respuestas Correctas',
          producto: ''
        },
        update_ok: {
          category: 'Actualización de Datos',
          action: 'Acceso',
          label: 'Registro Exitoso',
          event: 'ACT_DATOS Exitoso',
          producto: ''
        },
        pending: {
          category: 'Actualización de Datos',
          action: 'Error',
          label: 'Solicitud Pendiente',
          event: 'ACT_DATOS Solicitud Pendiente',
          producto: ''
        },
        questions_error: {
          category: 'Actualización de Datos',
          action: 'Error',
          label: 'Respuestas Incorrectas',
          event: 'ACT_DATOS Respuestas Incorrectas',
          producto: ''
        },
        server_error: {
          category: 'Actualización de Datos',
          action: 'Error',
          label: 'Error del Servidor',
          event: 'ACT_DATOS Server Error',
          producto: ''
        }
      },
      identify: new this.$amplitude.Identify(),
      amplitude: {
        events: {
          signupEnter: 'Registro Iniciado',
          recoveryPasswordEnter: 'Recuperación de Contraseña Iniciado',
          codeSent: 'Código Enviado',
          codeVerified: 'Código Verificado',
          SignupOK: 'Registro Finalizado',
          personalDataUpdated: 'Datos Actualizados',
          clientLocked: 'Cliente Bloqueado',
          firstLogin: 'First Login',
          login: 'Usuario Loggeado'
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['names', 'inititalValues']),
    passwordRequirements () {
      const password = this.txtPassVerifyData || ''
      const hasContent = password.length > 0
      return [
        {
          text: 'Al menos una mayúsculas y minúsculas.',
          valid: /[A-Z]/.test(password) && /[a-z]/.test(password),
          hasContent: hasContent
        },
        {
          text: 'Al menos un número.',
          valid: /\d/.test(password),
          hasContent: hasContent
        },
        {
          text: 'Al menos un carácter especial.',
          valid: /[^a-zA-Z0-9]/.test(password),
          hasContent: hasContent
        },
        {
          text: '8 caracteres como mínimo.',
          valid: password.length >= 8,
          hasContent: hasContent
        }
      ]
    },
    passwordProgress () {
      if (!this.txtPassVerifyData || this.txtPassVerifyData.length === 0) {
        return 0
      }
      const validCount = this.passwordRequirements.filter(req => req.valid).length
      return (validCount / 4) * 100
    },
    passwordProgressText () {
      if (!this.txtPassVerifyData || this.txtPassVerifyData.length === 0) {
        return 'Completa los requisitos de seguridad.'
      }
      const validCount = this.passwordRequirements.filter(req => req.valid).length
      switch (validCount) {
        case 0:
        case 1:
          return 'Completa los requisitos de seguridad.'
        case 2:
          return 'Vas completando los requisitos.'
        case 3:
          return 'Falta poco para completar los requisitos.'
        case 4:
          return 'Requisitos completos ¡Contraseña segura!'
        default:
          return 'Completa los requisitos de seguridad.'
      }
    },
    isPasswordFormValid () {
      // Validar que el email sea correcto (solo cuando se muestran los datos de contacto)
      if (this.updateDataInRecoveryMode && (!this.emailIsCorrect || !this.txtEmailVerifyData || this.txtEmailVerifyData.length === 0)) {
        return false
      }
      
      // Validar que haya contraseña nueva
      if (!this.txtPassVerifyData || this.txtPassVerifyData.length === 0) {
        return false
      }
      
      // Validar que todos los requisitos de seguridad se cumplan
      const allRequirementsValid = this.passwordRequirements.every(req => req.valid)
      if (!allRequirementsValid) {
        return false
      }
      
      // Validar que haya contraseña repetida y que coincidan
      if (!this.txtPassConfirmVerifyData || this.txtPassConfirmVerifyData.length === 0) {
        return false
      }
      
      // Validar que las contraseñas coincidan
      return this.txtPassVerifyData === this.txtPassConfirmVerifyData
    }
    /*
    ,
    timer () {
      return this.time.format('mm:ss')
    }
    */
  },
  methods: {
    ...mapActions('user', ['signIn', 'signInV2', 'recoveryPasswordOptions', 'signUpVersion2', 'getTypeOfClient', 'updatePassword', 'secretQuestions',
      'validateCecretQuestions', 'sendDataToRequirements', 'checkIfPolicyHasPendingOkActDatos', 'lockAccount', 'doResendCode']),
    ...mapActions('user', { authLogin: 'login' }),
    /**
     * Pide el OTP a CR Auth. En registro, si el documento ya tiene cuenta (409), se envía un código de
     * recuperación, igual que hacía el registro anterior con un usuario ya activo.
     * @returns {Promise<Object>} OtpChallenge
     */
    async requestOtp () {
      const request = {
        documentType: toDocumentType(this.tipoDocumento),
        documentNumber: this.numeroDocumento,
        channel: toChannel(this.optionSelected.value)
      }
      const recoveryRequest = async () => authIntegration.passwordRecovery(Object.assign({}, request, {
        recaptchaToken: toRecaptchaToken(await this.recaptchaMethod(RECAPTCHA_ACTIONS.RECOVERY), environment.isDev())
      }))
      if (this.source === 'recovery') {
        return recoveryRequest()
      }
      try {
        return await authIntegration.signup(Object.assign({}, request, {
          recaptchaToken: toRecaptchaToken(await this.recaptchaMethod(RECAPTCHA_ACTIONS.SIGNUP), environment.isDev())
        }))
      } catch (error) {
        if (error && error.code === AUTH_ERROR_CODES.AUTH_USER_ALREADY_REGISTERED) {
          return recoveryRequest()
        }
        throw error
      }
    },
    /**
     * Indica si el passwordSetupToken sigue vigente según el reloj local.
     * El 401 de Apigee por token vencido llega sin CORS, así que se controla antes de llamar.
     * @returns {boolean}
     */
    hasValidPasswordSetupToken () {
      return !!this.passwordSetupToken && Date.now() < this.passwordSetupExpiresAt
    },
    /**
     * El token para definir la contraseña venció o ya se usó: se vuelve a empezar el proceso.
     */
    restartAfterInvalidSetupToken () {
      this.passwordSetupToken = null
      this.loader = false
      this.$swal({
        imageUrl: this.icons.error,
        title: '¡Lo sentimos!',
        html: 'Algo salió mal. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
        confirmButtonText: 'Ok'
      }).then(() => {
        this.$router.push('/iniciar-sesion')
      })
    },
    /**
     * Genera un token de captcha único por cada intento
     * @param {string} actionType - Tipo de acción (RECAPTCHA_ACTIONS.LOGIN por defecto)
     * @returns {Promise<string>} Token de captcha generado
     */
    async recaptchaMethod (actionType = RECAPTCHA_ACTIONS.LOGIN) {
      try {
        if (process.env.ENVIRONMENT !== 'dev') {
          await this.$recaptchaLoaded()

          // Forzar a Google a generar token fresco limpiando el estado interno
          if (window.grecaptcha && window.grecaptcha.enterprise) {
            try {
              await window.grecaptcha.enterprise.ready(() => {})
            } catch (e) {
              console.log('grecaptcha.enterprise.ready error (ignorable):', e)
            }
          }

          const token = await this.$recaptcha(actionType)
          return token
        }
        return ''
      } catch (e) {
        console.error('SignUp recaptcha error: ', e)
        return ''
      }
    },
    activeQuestion1 (item) {
      this.dataQuestion1.forEach((v) => {
        v.active = false
      })
      item.active = true
      this.showQuestionVerifySection2 = true
    },
    activeQuestion2 (item) {
      this.dataQuestion2.forEach((v) => {
        v.active = false
      })
      item.active = true
      this.showQuestionVerifySection3 = true
    },
    activeQuestion3 (item) {
      this.dataQuestion3.forEach((v) => {
        v.active = false
      })
      item.active = true
      this.activeBtnQuestionVerify = true
    },
    verifychars (e) {
      var regex = new RegExp('^[a-zA-Z0-9 ]+$')
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        return true
      }
      e.preventDefault()
      return false
    },
    changeCodeCreateUser (e, pos) {
      var regex = new RegExp('^[a-zA-Z0-9 ]+$')
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        switch (pos) {
        case 1:
          this.$refs.input2.focus()
          break
        case 2:
          this.$refs.input3.focus()
          break
        case 3:
          this.$refs.input4.focus()
          break
        case 4:
          this.$refs.input5.focus()
          break
        case 5:
          this.$refs.input6.focus()
          break
        case 6:
          this.$refs.input1.focus()
          break
        }
      } else {
        e.preventDefault()
      }
      if (this.txt1CodeCreateUser !== '' && this.txt2CodeCreateUser !== '' && this.txt3CodeCreateUser !== '' && this.txt4CodeCreateUser !== '' && this.txt5CodeCreateUser !== '' && this.txt6CodeCreateUser !== '') {
        this.activeBtnCodeCreateUser = true
      } else {
        this.activeBtnCodeCreateUser = false
      }
    },
    changePassConfirm (e, validationInput = null) {
      // VALIDATE CORREO ELECTRONICO
      if (validationInput === 'email') {
        this.emailIsCorrect = this.onlyEmail(e)
      }
      // VALIDATE PASSWORD CORRECTO
      if (validationInput === 'password') {
        this.passwordIsValid = this.isPasswordValid(e)
      }
      // ACTUALIZAR ESTADO DEL BOTÓN USANDO LA COMPUTED PROPERTY
      this.activeBtnVerifyData = this.isPasswordFormValid
    },
    optionCreateUser (option) {
      let title = ''
      if (this.titleSignUp === 'Cambio de contraseña') {
        title = 'Cambiar contraseña'
      } else if (this.titleSignUp === 'Crear cuenta') {
        title = 'Crear cuenta'
      }

      let txtOption = option.value === 2 ? 'Celular' : 'Correo electrónico'
      // EVENT TRACK - Universal Analytics
      // EVENT UPDATED - 007 -- 016
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Medio de verificación - ' + txtOption
      })
      // EVENT TRACK - GA4
      // EVENT UPDATED - 007-- 016
      this.$gtm.trackEvent({
        event: 'select_checkbox',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Checkbox',
        TipoAccion: title,
        CTA: 'Medio de verificación - ' + txtOption
      })
      this.optionSelected = option
      this.activeBtnSendCodeCreateUser = true
    },
    async sendCode () {
      let self = this
      const goToCodeStep = () => {
        this.loader = false
        this.showCreateUserOption = false
        this.showCreateUserCode = true
        this.showSpamReminderIfEmail()
      }
      this.loader = true
      this.textLoading = 'Enviando'
      this.medioEnvio = this.optionSelected.value === 1 ? 'correo' : 'celular'

      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta'
      }
      let txtOption = this.optionSelected.value === 2 ? 'Celular' : 'Correo electrónico'
      // EVENT TRACK - Universal Analytics
      // UPDATE EVENT - 008  - 17
      // label: this.optionSelected.value === 1 ? 'Medio de verificación - Correo electrónico' : 'Medio de verificación - Celular'

      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Seleccionar - Enviar código - ' + txtOption
      })

      // EVENT TRACK - GA4
      // UPDATE EVENT - 008 -17
      // CTA: this.optionSelected.value === 1 ? 'Medio de verificación - Correo electrónico' : 'Medio de verificación - Celular'

      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title,
        CTA: 'Seleccionar - Enviar código',
        MedioVerificacion: txtOption
      })

      // TRACK EVENT - AMPLITUDE
      const callback = (opt) => {
        self.$amplitude.getInstance()
          .logEvent(
            self.amplitude.events.codeSent, {
              'Metodo de Validación': this.optionSelected.value === 1 ? 'Mail' : 'SMS',
              'Opción': opt
            }
          )
      }
      try {
        // Para evitar señales de enumeración, el flujo visual es el mismo aunque falle el envío.
        const challenge = await this.requestOtp()
        this.verificationId = challenge.verificationId
        const opt = this.source === 'recovery' ? 'Recuperar Contraseña' : 'Nuevo Registro'
        callback(opt)
      } catch (e) {
        this.verificationId = null
      }
      goToCodeStep()
    },
    async goToQuestion () {
      clearInterval(this.interval)
      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña - Verificación por código'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta - Verificación por código'
      }
      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 18

      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Seleccionar - Continuar'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE - 18
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title,
        CTA: 'Seleccionar - Continuar'
      })
      this.textLoading = 'Corroborando'
      this.loader = true
      const code = this.txt1CodeCreateUser + this.txt2CodeCreateUser + this.txt3CodeCreateUser + this.txt4CodeCreateUser + this.txt5CodeCreateUser + this.txt6CodeCreateUser

      try {
        if (!this.verificationId) {
          // No se pudo enviar el código: se trata igual que un código incorrecto
          throw new Error('Sin verificationId')
        }
        const verification = await authIntegration.otpVerify({ verificationId: this.verificationId, code: code.trim() })
        this.passwordSetupToken = verification.passwordSetupToken
        this.passwordSetupExpiresAt = Date.now() + (Number(verification.expiresIn) || 0) * 1000
        this.loader = false
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.codeVerified,
            {
              'Metodo de Validación': this.optionSelected.value === 1 ? 'Mail' : 'SMS'
            }
          )
        this.showCreateUserCode = false
        if (this.source === 'recovery') {
          this.showChangePass = true
        } else {
          // CR Auth no devuelve los datos de contacto: este paso solo pide la contraseña
          this.showCreateUserVerifyData = true
        }
      } catch (err) {
        this.loader = false
        const status = err && err.status
        if (!this.verificationId || (status >= 400 && status < 500)) {
          this.parrafErr = 'Ingresaste un código incorrecto. Por favor, inténtalo nuevamente.'
          this.showModalErr = true

          // EVENT TRACK - Universal Analytics
          // EVENT UPDATE - 021
          this.$gtm.trackEvent({
            event: 'virtualEvent',
            category: 'Zona Segura',
            action: title,
            label: 'Visualizar Modal - Lo sentimos'
          })
          // EVENT TRACK - GA4
          // EVENT UPDATE - 021
          this.$gtm.trackEvent({
            event: 'select_button',
            'Nombre Sección': 'Zona Segura',
            TipoElemento: 'Botón',
            TipoAccion: title,
            CTA: 'Visualizar Modal - Lo sentimos'
          })
        } else {
          this.$router.push({ name: 'Home' })
        }
      }
    },
    async resendCode () {
      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña - Verificación por código'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta - Verificación por código'
      }
      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 18
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Seleccionar - No he recibido el código de verificación'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE - 18
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title,
        CTA: 'Seleccionar - No he recibido el código de verificación'
      })
      if (this.verificationId) {
        try {
          const challenge = await authIntegration.otpResend({
            verificationId: this.verificationId,
            recaptchaToken: toRecaptchaToken(await this.recaptchaMethod(RECAPTCHA_ACTIONS.OTP_RESEND), environment.isDev())
          })
          this.verificationId = challenge.verificationId || this.verificationId
        } catch (e) {
          // Se mantiene el modal de hoy aunque CR Auth pida esperar (429): los textos nuevos los define negocio
        }
      }
      this.showModalResendCode = true
      // WHEN usuario mira el modal
      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 19
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Visualizar Modal - Reenvío de código'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE - 19
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title,
        CTA: 'Visualizar Modal - Reenvío de código'
      })
    },
    confirmResendCode () {
      let title = ''
      let titleGA4 = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña - Verificación por código'
        titleGA4 = 'Cambiar contraseña - Verificación por código - Modal'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta - Verificación por código'
        titleGA4 = 'Crear cuenta - Verificación por código - Modal'
      }
      this.showModalResendCode = false
      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 20
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Seleccionar Modal - Reenvío de código'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE - 020
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: titleGA4,
        CTA: 'Seleccionar Modal - Reenvío de código'
      })
    },
    showSpamReminderIfEmail () {
      if (!this.optionSelected || this.optionSelected.value !== 1) {
        return
      }
      this.showModalSpamReminder = true
    },
    goToVerifyData () {
      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña '
      } else if (this.source === 'signup') {
        title = 'Crear cuenta'
      }

      this.textLoading = 'Validando respuestas'
      this.loader = true
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title + ' - Actualizar datos - Paso 1',
        label: 'Seleccionar - Continuar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title + ' - Actualizar datos - Paso 1',
        CTA: 'Seleccionar - Continuar'
      })
      let selectedQuestion1 = this.dataQuestion1.filter((el) => {
        return el.active === true
      })
      let selectedQuestion2 = this.dataQuestion2.filter((el) => {
        return el.active === true
      })
      let selectedQuestion3 = this.dataQuestion3.filter((el) => {
        return el.active === true
      })
      // SI EXISTE PREGUNTAS SELECCIONADAS
      if (selectedQuestion1.length < 1 && selectedQuestion2.length < 1 && selectedQuestion3.length < 1) {
        this.parrafErr = 'Se debe seleccionar todas las preguntas para continuar con el proceso.'
        this.showModalErr = true
        return
      }
      let hash = { tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento, producto: selectedQuestion1[0].text, anio: selectedQuestion2[0].text, canal: selectedQuestion3[0].text }
      /*
      if (localStorage.getItem('attempt_login') === null) {
        localStorage.setItem('attempt_login', 0)
      }
      */
      this.validateCecretQuestions(hash)
        .then((res) => {
          this.loader = false
          let answers = res.data
          if (answers.respuesta === 'Correcto') {
            this.$gtm.trackEvent(this.trackEvents.questions_ok)
            // VALIDANDO EMAIL
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            this.emailIsCorrect = re.test(answers.correo.toLowerCase())
            // GUARDANDO DATOS ORIGINALES
            this.original.phone = answers.celular
            this.original.email = answers.correo
            // SETEANDO DATOS
            this.txtEmailVerifyData = answers.correo
            this.txtPhoneVerifyData = answers.celular
            this.codigoUsuario = answers.codigoUsuario
            this.showQuestionVerify = false
            this.showCreateUserVerifyData = true
          } else {
            // Registrando el intento
            /*
            var attempt_login = parseInt(localStorage.getItem('attempt_login'))
            localStorage.setItem('attempt_login', attempt_login + 1)
            attempt_login = parseInt(localStorage.getItem('attempt_login'))
            if (attempt_login < 3) {
              // Cambiando posición al arreglo de respuestas
              this.dataQuestion1.map((el) => { el.active = false })
              this.dataQuestion2.map((el) => { el.active = false })
              this.dataQuestion3.map((el) => { el.active = false })
              this.shuffleArray(this.dataQuestion1)
              this.shuffleArray(this.dataQuestion2)
              this.shuffleArray(this.dataQuestion3)
              // Cambiando posición al arreglo de respuestas
              this.$gtm.trackEvent(this.trackEvents.questions_error)
              this.parrafErr = (3 - attempt_login) === 1 ? 'Tienes 1 intento disponible. Por favor, verifica si la información es correcta. Por tu seguridad, contáctate con nuestro Servicio de atención al cliente al:' : 'Tienes ' + (3 - attempt_login) + ' intentos restantes. No respondiste correctamente las preguntas de verificación. Por tu seguridad, contáctate con nuestro Servicio de atención al cliente al:'
            } else {
              this.$gtm.trackEvent(this.trackEvents.questions_error)
              this.parrafErr = 'Tu cuenta ha sido bloqueada por seguridad. Para mayor información y solución, contáctate con nuestro Servicio de atención al cliente al:'
              this.lockAccount({ tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento, clave: '', saveData: 0 })
            }
            */
            // TRACK EVENT - AMPLITUDE
            this.$amplitude.getInstance()
              .logEvent(
                this.amplitude.events.clientLocked,
                {
                  'Intento': 1
                }
              )

              // EVENT TRACK - Universal Analytics
              // EVENT UPDATE - 021
            this.$gtm.trackEvent({
              event: 'virtualEvent',
              category: 'Zona Segura',
              action: title + ' - Verificación por código',
              label: 'Visualizar Modal - Lo sentimos'
            })
            // EVENT TRACK - GA4
            // EVENT UPDATE - 021
            this.$gtm.trackEvent({
              event: 'select_button',
              'Nombre Sección': 'Zona Segura',
              TipoElemento: 'Botón',
              TipoAccion: title + ' - Verificación por código',
              CTA: 'Visualizar Modal - Lo sentimos'
            })
            this.parrafErr = 'Tu cuenta ya no podrá actualizar los datos personales desde este momento. Para mayor información y solución, comunícate por nuestros '
            this.lockAccount({ tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento, clave: '', saveData: 0 })
            this.showModalErr = true
          }
        })
        .catch(() => {
          this.loader = false
          // Cambiando posición al arreglo de respuestas
          this.dataQuestion1.map((el) => { el.active = false })
          this.dataQuestion2.map((el) => { el.active = false })
          this.dataQuestion3.map((el) => { el.active = false })
          this.shuffleArray(this.dataQuestion1)
          this.shuffleArray(this.dataQuestion2)
          this.shuffleArray(this.dataQuestion3)
          // Cambiando posición al arreglo de respuestas
          this.$gtm.trackEvent(this.trackEvents.server_error)
          this.$swal({
            imageUrl: this.icons.error,
            title: '¡Lo sentimos!',
            html: 'Algo salió mal, no fue posible validar tu información para cambiar tus datos. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            confirmButtonText: 'Entendido'
          })
        })
    },
    changeForgotPassConfirm (e, validationInput = null) {
      // VALIDATE PASSWORD CORRECTO
      if (validationInput === 'password') {
        this.passwordIsValid = this.isPasswordValid(e)
      }
      // ACTUALIZAR ESTADO DEL BOTÓN: debe cumplir requisitos de seguridad y coincidir
      const allRequirementsValid = this.passwordRequirements.every(req => req.valid)
      const passwordsMatch = this.txtPassVerifyData === this.txtPassConfirmVerifyData
      const hasPassword = this.txtPassVerifyData && this.txtPassVerifyData.length > 0
      const hasConfirmPassword = this.txtPassConfirmVerifyData && this.txtPassConfirmVerifyData.length > 0
      
      this.activeBtnChangePass = allRequirementsValid && passwordsMatch && hasPassword && hasConfirmPassword
    },
    getRange (edad) {
      let range = ''
      if (edad >= 18 && edad <= 24) {
        range = '18-24'
      } else if (edad >= 25 && edad <= 34) {
        range = '25-34'
      } else if (edad >= 35 && edad <= 44) {
        range = '35-44'
      } else if (edad >= 45 && edad <= 54) {
        range = '45-54'
      } else if (edad >= 55 && edad <= 64) {
        range = '55-64'
      } else if (edad >= 65) {
        range = '65+'
      } else {
        range = '18-'
      }
      return range
    },
    async finishSignIn () {
      this.textLoading = 'Corroborando e ingresando información'
      this.loader = true
      let hash = {
        'clave': this.txtPassVerifyData
      }
      // Solo la actualización de datos usa ZS Backend; definir la contraseña tras el OTP no pide reCAPTCHA
      if (this.updateDataInRecoveryMode && process.env.ENVIRONMENT !== 'dev') {
        try {
          const updatePasswordToken = await this.recaptchaMethod(RECAPTCHA_ACTIONS.UPDATE_PASSWORD)
          hash.token = updatePasswordToken
        } catch (e) {
          hash.token = ''
        }
      }
      let formSingIn = {
        tipoDocumento: this.tipoDocumento,
        numeroDocumento: this.numeroDocumento,
        clave: this.txtPassVerifyData,
        saveData: true
      }
      
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Cambiar contraseña - Actualizar datos - Paso 2',
        label: 'Seleccionar - Continuar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Cambiar contraseña - Actualizar datos - Paso 2',
        CTA: 'Seleccionar - Continuar'
      })
      // SI NO ENTRÓ A RECUPERAR CONTRASEÑA Y ENTRO A ACTUALIZAR SUS DATOS EN EL FLUJO DE REGISTRO
      if (this.updateDataInRecoveryMode) {
        let form = {
          'transact': 'Actualización de datos',
          'name': this.nombreUsuario,
          'state': 'PENDIENTE',
          'product': 'Verificar Bases',
          'policy': 'Verificar Bases',
          'home_address': 'No aplica',
          'department': 'No aplica',
          'province': 'No aplica',
          'district': 'No aplica',
          'paternal_surname': this.apellidoPaterno,
          'maternal_surname': this.apellidoMaterno,
          'type_document': this.tipoDocumento === 1 ? 'DNI' : 'CE',
          'number_document': this.numeroDocumento,
          'cellphone': this.txtPhoneVerifyData,
          'phone': 'No aplica',
          'email': this.txtEmailVerifyData
        }
        // TRACK EVENT - AMPLITUDE
        const identify = this.identify.set('Numero Documento', this.numeroDocumento).set('Email', this.txtEmailVerifyData).set('Telefono', this.txtPhoneVerifyData)
        this.$amplitude.getInstance().identify(identify)
        // VERIFICAMOS SI TIENES ALGUN PENDIENTE EN ACT_DATOS
        this.checkIfPolicyHasPendingOkActDatos({ numDoc: this.numeroDocumento })
          .then((res) => {
            if (res.data.data.length < 1) {
              // UPDATE DEL PASSWORD
              this.updatePassword(hash)
                .then(async () => {
                  hash.token = ''
                  this.$amplitude.getInstance()
                    .logEvent(
                      this.amplitude.events.personalDataUpdated,
                      {
                        'Cambio de Pasword': false,
                        'Email': this.txtEmailVerifyData,
                        'Telefono': this.txtPhoneVerifyData
                      }
                    )
                  // TRACK EVENT - GA
                  this.$gtm.trackEvent(this.trackEvents.update_ok)
                  // DETECTANDO SI ALGUN DATO FUE CAMBIADO
                  if ((this.original.phone !== this.txtPhoneVerifyData) || (this.original.email !== this.txtEmailVerifyData)) {
                    // ENVIANDO DATA A LA DB DE REQUERIMIENTOS
                    this.sendDataToRequirements(form)
                      .then(async (res) => {
                        if (process.env.ENVIRONMENT !== 'dev') {
                          try {
                            const token = await this.recaptchaMethod(RECAPTCHA_ACTIONS.AUTO_LOGIN)
                            formSingIn.token = token
                          } catch (e) {
                            console.error('Error generando captcha para auto-login: ', e)
                          }
                        }
                        // HACIENDO LOGIN CON LO NUEVO
                        this.signInV2(formSingIn)
                          .then((res) => {
                            formSingIn.token = ''
                            this.amplitudeSignUpRecovery(res, this.txtEmailVerifyData, this.txtPhoneVerifyData)
                          })
                          .catch((err) => {
                            formSingIn.token = ''
                          })
                      })
                      .catch(() => {
                        // console.log('Send Req: ', err)
                        // this.$gtm.trackEvent(this.trackEvents.server_error)
                        this.$swal({
                          imageUrl: this.icons.error,
                          title: '¡Lo sentimos!',
                          html: 'Algo salió mal. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                          confirmButtonText: 'Ok'
                        }).then((result) => {
                          this.$router.push('/iniciar-sesion')
                        })
                      })
                  } else {
                    if (process.env.ENVIRONMENT !== 'dev') {
                      try {
                        const token = await this.recaptchaMethod(RECAPTCHA_ACTIONS.AUTO_LOGIN)
                        formSingIn.token = token
                      } catch (e) {
                        console.error('Error generando captcha para auto-login: ', e)
                      }
                    }
                    // HACIENDO LOGIN
                    this.signInV2(formSingIn)
                      .then((res) => {
                        formSingIn.token = ''
                        this.amplitudeSignUpRecovery(res, this.txtEmailVerifyData, this.txtPhoneVerifyData)
                      })
                      .catch((err) => {
                        formSingIn.token = ''
                      })
                  }
                })
                .catch((err) => {
                  hash.token = ''
                  this.loader = false
                  if (err.data && err.data.mensajeRespuesta && (
                      err.data.mensajeRespuesta.includes('formato inválido') ||
                      err.data.mensajeRespuesta.includes('formato') ||
                      err.data.mensajeRespuesta.includes('contraseña'))) {
                    this.$swal({
                      titleText: 'Error de validación',
                      text: err.data.mensajeRespuesta || 'La contraseña no cumple con el formato requerido',
                      confirmButtonText: 'Entendido'
                    })
                  } else {
                    // console.log('err: ', err)
                    // this.$gtm.trackEvent(this.trackEvents.server_error)
                    this.$swal({
                      imageUrl: this.icons.error,
                      title: '¡Lo sentimos!',
                      html: 'Algo salió mal. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
                      confirmButtonText: 'Ok'
                    }).then((result) => {
                      this.$router.push('/iniciar-sesion')
                    })
                  }
                })
            } else {
              this.loader = false
              this.$gtm.trackEvent(this.trackEvents.pending)
              this.$swal({
                title: '¡Solicitud en proceso!',
                html: 'Tu solicitud de actualización de datos se encuentra en proceso. Podrás volver a intentarlo en 24 horas.',
                confirmButtonText: 'Ok'
              }).then((result) => {
                this.$router.push('/iniciar-sesion')
              })
            }
          })
          .catch(() => {
            this.$gtm.trackEvent(this.trackEvents.server_error)
            this.$swal({
              imageUrl: this.icons.error,
              title: '¡Lo sentimos!',
              html: 'Algo salió mal. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              confirmButtonText: 'Ok'
            }).then((result) => {
              this.$router.push('/iniciar-sesion')
            })
          })
      } else {
        // SI ENTRÓ A RECUPERAR CONTRASEÑA O A REGISTRARSE: SE DEFINE CON EL TOKEN DEL OTP (portal-api vía Apigee)
        if (!this.hasValidPasswordSetupToken()) {
          this.restartAfterInvalidSetupToken()
          return
        }
        let setupResponse
        try {
          setupResponse = await passwordIntegration.setup(this.passwordSetupToken, this.txtPassVerifyData)
        } catch (err) {
          if (err && err.status === 401) {
            // portal-api: token vencido o ya usado
            this.restartAfterInvalidSetupToken()
            return
          }
          this.loader = false
          return
        }
        if (setupResponse.codigoRespuesta !== '01') {
          // 98 formato y 97 igual a la anterior no consumen el token: el usuario puede corregir y reintentar
          this.loader = false
          const mensaje = setupResponse.mensajeRespuesta
          if (PASSWORD_SETUP_RETRY_CODES.includes(setupResponse.codigoRespuesta) || (mensaje && (mensaje.includes('formato') || mensaje.includes('contraseña')))) {
            this.$swal({
              titleText: 'Error de validación',
              text: mensaje || 'La contraseña no cumple con el formato requerido',
              confirmButtonText: 'Entendido'
            })
          }
          return
        }
        this.passwordSetupToken = null
        formSingIn.token = await this.recaptchaMethod(RECAPTCHA_ACTIONS.LOGIN)
        try {
          const res = await this.authLogin(formSingIn)
          formSingIn.token = ''
          this.amplitudeSignUpRecovery(res, this.txtEmailVerifyData, this.txtPhoneVerifyData)
        } catch (err) {
          formSingIn.token = ''
        }
      }
    },
    amplitudeSignUpRecovery (res, email, cel) {
      let self = this
      // let callback = function (productos) {
      self.loader = false
      self.$amplitude.getInstance().logEvent(self.amplitude.events.personalDataUpdated, { 'Cambio de Pasword': true })
      let signupInit = localStorage.getItem('signup_init')
      const hashId = getHashIS(self.tipoDocumento.toString().padStart(2, '0'), self.numeroDocumento)
      // GA4 - HashID
      self.$gtm.trackEvent({
        userID: hashId,
        loginStatus: 'Sesión Iniciada',
        empresa: 'Interseguro'
      })

      let identify = new self.$amplitude.Identify().set('Numero Documento', self.numeroDocumento)

      if (cel && cel !== '') {
        identify = identify.set('Email', email).set('Telefono', cel).set('Edad', res.data.edad || 0)
          .set('Edad Promedio', self.getRange(res.data.edad) || '')// .set('Producto', JSON.parse(productos))
      }
      // [SE AGREGO EN EL IDENTIFY EL "ESTADO USUARIO" PARA FIRST LOGIN. POR ELLO DICHO CAMBIO EN LAS LINEAS 906 y 913]
      if (signupInit && signupInit === '1') {
        self.firstLoginEvent = () => {
          // EVENT TRACK  Universal Analytics
          self.$gtm.trackEvent({
            event: 'virtualEvent',
            category: 'Zona Segura',
            action: 'Primer inicio de sesión',
            label: 'Ingreso satisfactorio'
          })
          // EVENT TRACK  GA4
          self.$gtm.trackEvent({
            event: 'select_button',
            'Nombre Sección': 'Zona Segura',
            TipoElemento: 'Botón',
            TipoAccion: ' Primer inicio de sesión ',
            CTA: 'Ingreso satisfactorio'
          })
          self.$amplitude.getInstance().logEvent(self.amplitude.events.firstLogin, { 'DNI': self.numeroDocumento })
        }

        // EVENT TRACK  Universal Analytics
        self.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Crear cuenta',
          label: 'Registro completado'
        })
        // EVENT TRACK  GA4
        self.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Crear cuenta',
          CTA: 'Registro completado'
        })

        // SET NEW VALUE
        identify = identify.set('Estado Usuario', 'Usuario Logueado')
        // SET DEFINITIONS IN AMPLITUDE
        // self.$amplitude.getInstance().setUserId(self.numeroDocumento)
        self.$amplitude.getInstance().identify(identify)
        // SET EVENT - SE REMUEVE EL PARAMETRO DNI SEGUN DEFINICION
        self.$amplitude.getInstance().logEvent(self.amplitude.events.SignupOK)
        // ACA EN EL EVENT LOGIN NO SE SETEA LA CANTIDAD DE LOGINS PORQUE SE REFIERE AL FIRST-LOGIN
        localStorage.removeItem('signup_init')
      } else {
        // SET AMPLITUDE
        self.$amplitude.getInstance().setUserId(self.numeroDocumento)
        self.$amplitude.getInstance().identify(identify)
        // SIEMPRE VA A SER 1 PORQUE DESPUES DEL SIGNUP, SIEMPRE VENDRA EL 1er LOGIN - DUUUH!!
        // SE SETEA EL VALOR DE CANTIDAD-LOGUEOS   EN ESTE EVENTO SEGUN DEFINICION - DUDE!!
        self.$amplitude.getInstance().logEvent(self.amplitude.events.login, { 'DNI': self.numeroDocumento, 'Cantidad de Logueos': 1 })
      }

      self.showModal = true
      // }
      /*
      self.getTypeOfClient({ tipoDocumento: self.tipoDocumento, numeroDocumento: self.numeroDocumento })
        .then((type) => {
          callback(type.data.tipo)
        }).catch((err) => {
          console.log('err: ', err)
          const tipo = ''
          callback(tipo)
        })
      */
    },
    goToHome (firsLogin) {
      if (firsLogin && this.firstLoginEvent) {
        this.firstLoginEvent()
      }
      localStorage.removeItem('attempt_login')
      this.$router.push({ name: 'Home' })
    },
    goToLogin () {
      // this.$router.push({ name: 'MakeLogin' })
      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta'
      }

      if (this.showModalErr) {
        // EVENT TRACK - Universal Analytics
        // EVENT update - 012 - 22
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: title + ' - Verificación por código',
          label: 'Seleccionar Modal - Lo sentimos'
        })
        // EVENT TRACK - GA4
        // EVENT update - 012 - 22
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: title + ' - Verificación por código - Modal',
          CTA: 'Seleccionar Modal - Lo sentimos'
        })
      }
      this.showModalErr = false
      this.$router.push({ name: 'MakeLogin' })
    },
    onlyNumbers (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    },
    onlyEmail (e) {
      let sVal = document.querySelector('#txtEmailVerifyData').value
      const re = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*$/i
      // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(sVal.toLowerCase())
    },
    isPasswordValid (e) {
      let inputElement = document.querySelector('#txtPassVerifyData')
      let sVal = (inputElement && inputElement.value) || this.txtPassVerifyData || ''
      if (sVal.length > 20) {
        return false
      }
      const validation = validatePasswordFormat(sVal)
      return validation.isValid
    },
    showUpdateDataPopup () {
      this.$swal({
        title: '¡Atención!',
        html: 'Para actualizar tus datos de contacto, por favor comunícate con nuestros canales de atención y te ayudaremos a completar este proceso.',
        imageUrl: require('@/assets/characters/informa.svg'),
        imageHeight: 150,
        imageWidth: 150,
        confirmButtonText: 'Conócelos aquí'
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://www.interseguro.pe/ayuda', '_blank');
        }
      });
    },
    sendUpdateData () {
      let title = ''
      if (this.source === 'recovery') {
        title = 'Cambiar contraseña'
      } else if (this.source === 'signup') {
        title = 'Crear cuenta'
      }

      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE 008- 17
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: title,
        label: 'Seleccionar - Quiero actualizar mi celular y/o correo electrónico'
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE 008- 17
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: title,
        CTA: 'Seleccionar - Quiero actualizar mi celular y/o correo electrónico',
        MedioVerificacion: '{Medio de verificación}'
      })
      this.$gtm.trackEvent(this.trackEvents.access)
      this.dataQuestion1 = []
      this.dataQuestion2 = []
      this.dataQuestion3 = []
      this.textLoading = 'Obteniendo información'
      this.loader = true
      this.titleVerifyData = 'Actualiza tus datos'
      this.subTitleVerifyData = 'Ingresa tus datos y crea tu contraseña.'
      this.txtPhoneVerifyData = ''
      this.txtEmailVerifyData = ''
      this.updateDataInRecoveryMode = true
      let hash = { tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento }
      this.secretQuestions(hash)
        .then((res) => {
          let questions = res.data
          if (questions[0].producto !== 'locked' && questions[0].canal !== 'locked') {
            for (let index = 0; index < questions.length; index++) {
              let question1 = { active: false, id: index + 1, text: questions[index].producto }
              this.dataQuestion1.push(question1)
              let question2 = { active: false, id: index + 1, text: questions[index].fechaVigenciaPoliza }
              this.dataQuestion2.push(question2)
              let question3 = { active: false, id: index + 1, text: questions[index].canal }
              this.dataQuestion3.push(question3)
            }
            // Cambiando posición al arreglo de respuestas
            this.shuffleArray(this.dataQuestion1)
            this.shuffleArray(this.dataQuestion2)
            this.shuffleArray(this.dataQuestion3)
            // Cambiando posición al arreglo de respuestas
            this.loader = false
            this.showCreateUserOption = false
            this.showQuestionVerify = true
          } else {
            this.loader = false
            this.parrafErr = 'No es posible actualizar tus datos personales. Para más información y solución, por favor comunícate por nuestros '
            this.showModalErr = true

            // EVENT TRACK - Universal Analytics
            // EVENT UPDATE - 021
            this.$gtm.trackEvent({
              event: 'virtualEvent',
              category: 'Zona Segura',
              action: title + ' - Verificación por código',
              label: 'Visualizar Modal - Lo sentimos'
            })
            // EVENT TRACK - GA4
            // EVENT UPDATE - 021
            this.$gtm.trackEvent({
              event: 'select_button',
              'Nombre Sección': 'Zona Segura',
              TipoElemento: 'Botón',
              TipoAccion: title + ' - Verificación por código',
              CTA: 'Visualizar Modal - Lo sentimos'
            })
          }
        })
        .catch(() => {
          this.loader = false
          this.$gtm.trackEvent(this.trackEvents.questions_error)
          this.$swal({
            imageUrl: this.icons.error,
            title: '¡Lo sentimos!',
            html: 'Algo salió mal, no fue posible validar tu información para cambiar tus datos. Por favor, inténtalo nuevamente o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            confirmButtonText: 'Entendido'
          })
        })
    },
    showHidePassword () {
      if (!this.showPassword) {
        this.showPassword = true
        this.typePassword = 'text'
        this.icons.eyeSelected = this.icons.eyeOpen
      } else {
        this.showPassword = false
        this.typePassword = 'password'
        this.icons.eyeSelected = this.icons.eyeClose
      }
    },
    shuffleArray (t) {
      let last = t.length
      let n
      while (last > 0) {
        n = rand(last)
        this.swap(t, n, --last)
      }
    },
    swap (t, i, j) {
      let q = t[i]
      t[i] = t[j]
      t[j] = q
      return t
    }
  },
  mounted () {
    const self = this
    /** CAMBIO DE TEXTO DEPENDIENDO DE DONDE VENGA */
    clearInterval(this.interval)
    /** CORROBORAR SI SE TIENE TODOS LOS DATOS PARA REGISTRARSE */
    if (!this.numeroDocumento && !this.tipoDocumento) {
      this.$swal({
        title: 'Atención',
        text: 'Primero debes ingresar tu número de documento de identidad.',
        confirmButtonText: 'Volver al inicio'
      }).then((result) => {
        this.$router.push('/iniciar-sesion')
      })
    } else {
      if (self.source === 'signup') {
        const identify = self.identify.set('Numero Documento', self.numeroDocumento)
        self.$amplitude.getInstance().identify(identify)
        self.$amplitude.getInstance().setUserId(self.numeroDocumento)
        self.$amplitude.getInstance().logEvent(
          self.amplitude.events.signupEnter,
          {
            'Registro Iniciado': 1,
            'DNI': self.numeroDocumento
          }
        )
        localStorage.setItem('signup_init', '1')
        self.titleSignUp = 'Gestión de acceso'
        self.subTitleSignUp = 'Selecciona una de estas opciones de contacto para validar tus datos'
        self.titleVerifyData = 'Actualiza tus datos'
        self.subTitleVerifyData = 'Valida tus datos de contacto y crea tu contraseña.'
        self.txtLastStep = '¡Has creado tu cuenta con éxito!'
        // En registro, siempre mostramos ambas opciones para evitar señales de enumeración.
        self.options = [{ value: 1 }, { value: 2 }]
        return
      }

      if (self.source === 'recovery') {
        const identify = self.identify.set('Numero Documento', self.numeroDocumento)
        self.$amplitude.getInstance().identify(identify)
        self.$amplitude.getInstance()
          .logEvent(
            self.amplitude.events.recoveryPasswordEnter,
            {
              'Recuperacion de Contraseña Iniciado': 1
            }
          )
        self.txtPhoneVerifyData = ''
        self.titleSignUp = 'Gestión de acceso'
        self.subTitleSignUp = 'Selecciona una de estas opciones de contacto para validar tus datos'
        self.titleVerifyData = 'Actualiza tus datos'
        self.subTitleVerifyData = 'Valida tus datos de contacto y crea tu contraseña.'
        self.txtLastStep = 'Tu contraseña fue cambiada con éxito'
        // En recuperación, también mostramos ambas opciones para evitar señales de enumeración.
        self.options = [{ value: 1 }, { value: 2 }]
        return
      }

      var requestDocument = { tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento }
      this.recoveryPasswordOptions(requestDocument)
        .then((res) => {
          // this.loading = false
          self.$gtm.trackEvent({
            event: 'RE correcto',
            category: 'Registro',
            action: 'REacceso',
            label: 'Ingreso correcto al registro'
          })
          const identify = self.identify.set('Numero Documento', self.numeroDocumento)
          self.$amplitude.getInstance().identify(identify)
          if (self.source === 'recovery') {
            // TRACK EVENT - AMPLITUDE
            self.$amplitude.getInstance()
              .logEvent(
                self.amplitude.events.recoveryPasswordEnter,
                {
                  'Recuperacion de Contraseña Iniciado': 1
                }
              )
            self.txtPhoneVerifyData = ''
            self.titleSignUp = 'Gestión de acceso'
            self.subTitleSignUp = 'Selecciona una de estas opciones de contacto para validar tus datos'
            self.titleVerifyData = 'Actualiza tus datos'
            self.subTitleVerifyData = 'Valida tus datos de contacto y crea tu contraseña.'
            self.txtLastStep = 'Tu contraseña fue cambiada con éxito'
          }

          if (res.data.celular && res.data.correo) {
            self.options = [{ value: 1 }, { value: 2 }]
          } else if (res.data.celular) {
            self.options = [{ value: 2 }]
          } else if (res.data.correo) {
            self.options = [{ value: 1 }]
          } else {
            self.$swal({
              imageUrl: this.icons.oops,
              title: '¡Oops, algo salió mal!',
              text: 'No se pudo obtener tu información de contacto. Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en 5 minutos.',
              confirmButtonText: 'Entendido'
            }).then(() => {
              self.$router.push('/').catch(() => {})
            })
          }
        })
        .catch(() => {
          // this.loading = false
          // console.log('err: ', err)
          self.$gtm.trackEvent({
            event: 'RE Error de servidor',
            category: 'Registro',
            action: 'REerror',
            label: 'Error u inconveniente al obtener datos para enviar código.'
          })
        })
    }
  },
  components: {
    'form-signup': FormSignup,
    Navbar,
    Cover,
    SpamReminderModal
  }
}
</script>

<style>
  @import url('../assets/css/general.css');
  .sign-up-overlay{
    background-color: rgba(0,0,0,0.7);
    height: 100vh;
    left: 0;
    position: absolute;
    top: 0;
    z-index:99;
    width: 100%;
  }

  .sign-up-modal{
    background: white;
    /* left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    top:15%; */
    padding: 20px;
    /* position: absolute; */
    /* max-width: 100%; */
    /* width: 320px; */
    /* max-width: 100%; */
    z-index:999;
    border-radius: 4px;
  }
  /* Efecto hover botón */
  .hover-scale:hover{
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -o-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
  .sign-up-modal img{
    max-width: 100%;
  }
  .sign-up-modal h2 {
    font-size: 18px;
    margin: 10px auto 0 auto;
  }
  .sign-up-modal button {
    border-radius: 4px;
    font-size: 18px;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 30px auto 20px auto;
    width: 145px;
    user-select: none;
  }

  .sign-up-modal p {
    color: #535D66;
    font-size: 16px;
    line-height: 1.3;
  }
  .size-13px {
    font-size: 13px;
    line-height: normal;
  }
  .size-12px {
    font-size: 12px;
  }
  .sign-up-verify-data .v-text-field .v-input__control .v-input__slot,
  .sign-up-verify-data .v-text-field .v-input__control .v-input__slot:hover {
    border: 1px solid #B1B8C4!important;
  }
  .sign-up-verify-data .v-text-field .v-input__control .v-input__slot .v-text-field__slot input:-internal-autofill-selected {
    background-color: rgb(255, 255, 255) !important;
    background-image: none !important;
    color: rgba(0,0,0) !important;
  }
  .sign-up-verify-data .v-text-field .v-input__control .v-input__slot .v-text-field__slot input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }
  .back-blue {
    background: #0855C4!important;
    color:white!important;
  }
  .sign-up input {
    font-family: "Omnes Regular", sans-serif;
  }
  .sign-up-btn-login {
    margin-bottom: 30px;
    margin-top: 22px;
  }
  .sign-up-btn-create-user {
    margin-bottom: 50px;
    width: 100%;
  }
  .sign-up-col-two-container{
    margin: auto;
    width: 90%;
  }
  .sign-up-col-two-main {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;
    margin-bottom: 8%;
  }
  .sign-up-col-two-main article h2,
  .sign-up-col-two-main article.sign-up-verify-data h3 {
    color: var(--first-brand-color);
    font-weight: 400;
    font-size: 24px;
  }
  .sign-up-col-two-main article .text-instruction {
    color: var(--text-color);
    font-weight: 400;
    font-size: 16px;
    margin: 5px 0 0;
  }

  .sign-up-col-two-main article .sign-up-send-code {
    margin: 35px 0 30px;
  }
  .sign-up-col-two-main article.sign-up-verify-data h3 {
    font-weight: normal;
    font-family: 'Omnes Medium';
    color: #0855C4;
    margin-top: 30px;
    margin-bottom: 5px;
    font-size: 16px;
  }
  .sign-up-col-two-main article.sign-up-verify-data h3.mt-1 {
    margin-top: 15px !important;
  }

  .sign-up-col-two-main article.sign-up-verify-data .terms {
    font-size: 13px;
    line-height: normal;
    letter-spacing: 0.3px;
    text-align: justify;
  }
  .sign-up-remember-password {
    position: relative;
    margin-top: 8px;
    margin-bottom: 30px;
  }
  .sign-up-remember-password label {
    cursor: pointer;
    margin-left: 25px;
  }
  .sign-up-remember-password label:after,
  .sign-up-remember-password label:before {
    content: '';
    top:50%;
    position: absolute;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -ms-transition: all 0.3s;
    transition: all 0.3s;
  }
  .sign-up-remember-password label:after {
    border: 2px solid white;
    border-top: none;
    border-right: none;
    height: 6px;
    left: 6px;
    opacity: 0;
    transform:  translateY(-50%) rotate(-45deg);
    width: 12px;
  }
  .sign-up-remember-password input {
    left: 0;
    height: 20px;
    top:50%;
    position: absolute;
    transform: translateY(-50%);
    visibility: hidden;
    width: 20px;
  }
  .sign-up-remember-password label:before {
    border: 1px solid#B1B8C4;
    border-radius: 50%;
    height: 16px;
    left: 0;
    transform: translateY(-50%);
    width: 16px;
  }
  .sign-up-create-user-data {
    margin: 0 auto 13%;
    width: 60%;
  }
  .sign-up-remember-password input:checked ~ label:before {
    background-color: var(--second-brand-color);
    border-color: var(--second-brand-color);
  }
  .sign-up-remember-password input:checked + label:after {
    opacity: 1;
  }
  .sign-up-col-two-main article {
    /* margin-top: 7%; */
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    max-width: 95%;
  }
  .sign-up-change-password h3 { font-weight: normal; }
  .sign-up-change-password .v-text-field .v-input__control .v-input__slot,
  .sign-up-change-password .v-text-field .v-input__control .v-input__slot:hover {
    border: 1px solid #B1B8C4!important;
  }
  .sign-up-email-phone label {
    background: #F4F5FA;
    height: 65px;
    position: relative;
    margin-top: 20px;
  }
  .sign-up-email-phone input {
    left: 0;
    height: 20px;
    top:50%;
    position: absolute;
    transform: translateY(-50%);
    visibility: hidden;
    width: 20px;
  }
  .sign-up-email-phone span{
    display: block;
    font-weight: normal;
  }
  .sign-up-email-phone p:after,
  .sign-up-email-phone p:before {
    content: '';
    position: absolute;
    top: 50%;
  }
  .sign-up-email-phone p:after {
    border: 2px solid white;
    border-top: none;
    border-right: none;
    height: 6px;
    left: 21px;
    opacity: 0;
    transform:  translateY(-50%) rotate(-45deg);
    width: 12px;
  }
  .sign-up-email-phone p:before {
    border: 1px solid #B1B8C4;
    border-radius: 50%;
    height: 23px;
    left: 15px;
    transform: translateY(-50%);
    width: 23px;
  }
  .sign-up-email-phone p {
    padding-left: 55px;
  }
  .sign-up-email-phone input:checked ~ p:before {
    background-color: #0855C4;
    border-color: #0855C4;
  }
  .sign-up-email-phone input:checked ~ p:after {
    opacity: 1;
  }
  .sign-up-email-phone input:checked ~  p span {
    color: #0855C4;
    transition: all .2s ease-in-out;
  }
  .sign-up-code {
    background: #F4F5FA;
    padding: 20px 0 10px;
  }

  .sign-up-code h3 {
    color: var(--text-color);
    font-size: 20px;
  }
  .sign-up-code div {
    justify-content: center;
    gap: 20px;

  }
  .sign-up-code input {
    align-items: center;
    background: white;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    color: var(--text-color);
    display: flex;
    font-weight: bold;
    height: 40px;
    font-size: 18px;
    justify-content: center;
    text-align: center;
    width: 35px;
  }
  .sign-up-code input:focus,
  .sign-up-code input:hover {
    border: 1px solid #D9D9D9;
    outline: unset;
  }
  .sign-up-verify-data .v-input__control {
    height: 73px!important;
  }
  .sign-up-verify-data .v-text-field.v-input--is-disabled .v-input__control .v-input__slot .v-text-field__slot input {
    color: var(--text-color);
  }
  .sign-up-verify-data .v-text-field.v-input--is-label-active .v-input__control .v-input__slot .v-text-field__slot label,
  .sign-up-verify-data .v-text-field.v-input--is-focused .v-input__control .v-input__slot .v-text-field__slot label {
    font-family: 'Omnes Medium';
    color: var(--text-color);
  }
  .sign-up-question-verify h3 {
    font-size: 0.98rem;
  }
  .sign-up-question-verify .g-flex {
    justify-content: space-between;
  }
  .sign-up-question-verify .g-flex p {
    align-items: center;
    background: #F5F7FD;
    cursor: pointer;
    display: flex;
    font-size: 0.85rem;
    justify-content: center;
    margin-top: 10px;
    padding: 7px 0;
    text-align: center;
    width: 80px;
  }
  .contact-sac { margin-top: 3%; }
  .contact-sac img {
    position: relative;
    top: 6px;
    margin-right: 5px;
  }
  .v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner {
    justify-content: flex-end;
    padding-right: 4px;
  }
  .v-input.eye-password .v-input__control .v-input__slot .v-input__append-inner img {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    cursor: pointer;
  }
  /* Borde azul cuando está en focus y está vacío */
  .v-input.eye-password.v-input--is-focused:not(.has-content) .v-input__control .v-input__slot {
    border: 1px solid #0855C4 !important;
  }
  /* Borde gris cuando tiene contenido (sobrescribe el azul incluso en focus) */
  .v-input.eye-password.has-content .v-input__control .v-input__slot {
    border: 1px solid #B1B8C4 !important;
  }
  /* Password Checklist Styles */
  .password-checklist {
    background-color: white;
    padding: 12px;
    margin-top: 8px;
    border: 1px solid #919191;
  }
  .password-progress-container {
    margin-bottom: 12px;
  }
  .password-progress-bar {
    width: 100%;
    height: 4px;
    background-color: #919191;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .password-progress-fill {
    height: 100%;
    background-color: #1FAF38;
    border-radius: 4px;
    transition: width 0.3s ease;
  }
  .password-progress-title {
    font-size: 13px;
    color: #454A6C;
  }
  .password-description {
    font-size: 13px;
    color: #424242;
    font-family: 'Omnes Regular';
    line-height: 1.4;
  }
  @media only screen and (max-width: 600px) {
    .password-description {
      text-align: center;
    }
  }
  .password-requirement {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
  }
  .password-requirement:last-child {
    margin-bottom: 0;
  }
  .check-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .check-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .check-invalid {
    background-color: white;
    border: 1px solid #B1B8C4;
    border-radius: 50%;
  }
  .check-error {
    background-color: white;
    /* border: 1px solid #F44336; */
    border-radius: 50%;
  }
  .requirement-text {
    font-family: 'Omnes Regular';
    color: #424242;
  }

  /* Small to large handset ----------- */
  @media only screen and (max-width: 395px) {
    .sign-up-create-user-data {
      width: 70%;
    }
  }
  @media only screen and (max-width: 600px) {
    .sign-up-col-two-main {
      margin-bottom: 1em;
    }
    .sign-up-code {
      margin: 30px 0;
    }
    .sign-up-code div {
      gap: 12px;
    }
    .sign-up-col-two-main article.sign-up-verify-data h3 {
      margin-top: 20px!important;
    }
    .sign-up-col-two-main article.sign-up-verify-data h3.mt-1 {
      margin-bottom: 0!important;
    }
    .sign-up-btn-verify-data {
      margin-top: 35px;
      margin-bottom: 35px !important;
    }
  }
  @media only screen and (max-width: 1023px) {
    .sign-up-col-two {
      background-image: url('../assets/login/bg-white-mobile.svg');
      background-size: contain;
      background-repeat: no-repeat;
      margin-top: -50px;
    }
  }
  @media screen and (min-width: 600px) {
  .sign-up-col-two {
    background-size: cover;
    margin-top: -80px;
  }
}
  @media screen and (min-width: 1024px){
    .sign-up {
      display:flex;
    }

    .sign-up-col-two {
      margin-top: 0;
    }

    .sign-up-col-two-main {
      margin: 0 auto;
    }

    .sign-up-col-two-main article {
      margin-top: 7%;
      max-width: 73%;
    }

    .sign-up-col-two-main article.sign-up-verify-data {
      margin: 0 auto;
    }

    .sign-up-col-two {
      min-height: 670px;
      height: calc(100vh - 60px);
      width: 50%;
    }
    .sign-up-email-phone {
      margin: 20px 0 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/SignUp.vue